import { AuthService } from './../../services/auth.service';
import { Subscription } from 'rxjs';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ActivatedRoute, Router } from '@angular/router';
import { OnInit, Injector, AfterContentChecked, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BaseModel } from '../../models/base.model';
import { BaseService } from '../../services/base.service';

export abstract class BaseFormComponent<T extends BaseModel> implements OnInit, OnDestroy, AfterContentChecked {

    // dependecy
    protected redirect: Router;
    protected activetedRoute: ActivatedRoute;
    protected formBuilder: FormBuilder;
    protected toastr: ToastrManager;
    public objectForm: FormGroup;
    public auth: AuthService;

    // proprieties
    @ViewChild('iptFile') public  imageFile: ElementRef
    protected formSubscription: Subscription;
    public isButtonLoading: boolean;
    public pageTitle: string;
    public currentAction: string;
    // formcontrolname for array of images
    public imageInputControlName:string;
    // formcontrolname for arrar of id's
    public arrayInputControlName:string;

    public arrayOfimages:Array<any>;
    public arrayOfimagesUrls:Array<string>;
    public object: T;

    constructor(
        protected injector: Injector,
        protected objTypeName: string,
        protected backRoute: string,
        protected copyJsonDataToObjectFunction: (jsonData: any) => T,
        protected baseService: BaseService<T>
    ){
        this.initParentProprieties()
        this.initChildProprieties()
    }

    private  initParentProprieties() {
        this.activetedRoute = this.injector.get(ActivatedRoute);
        this.auth = this.injector.get(AuthService);
        this.redirect = this.injector.get(Router);
        this.formBuilder = this.injector.get(FormBuilder);
        this.toastr = this.injector.get(ToastrManager);
        this.formSubscription = new Subscription();
        this.isButtonLoading = false;
        this.arrayOfimages=new Array<any>();
        this.arrayOfimagesUrls=new Array<string>();
        this.imageFile=new ElementRef(null);
    }

    // init child proprieties
    protected abstract initChildProprieties(): void

    ngAfterContentChecked(): void {
        this.setPageTitle();
    }

    protected setPageTitle() {

        if (this.currentAction == 'new') {

            this.pageTitle = this.creationPageTitle();

        } else if (this.currentAction == 'unknown') {

            this.pageTitle = this.setChildPageTitle()

        } else {

            this.pageTitle = this.editionPageTitle();

        }

    }

    protected creationPageTitle(): string {
        return "Novo"
    }

    protected editionPageTitle(): string {
        return "Edição"
    }

    ngOnDestroy(): void {
        if (!this.formSubscription) return

        this.formSubscription.unsubscribe()

        this.resetBehaviorSubject()
    }

    protected resetBehaviorSubject(){
        this.baseService.setObject(null,this.objTypeName)

        localStorage.removeItem(this.objTypeName)
    }

    ngOnInit() {
        this.setCurrentAction();
        this.buildForm();
        this.loadObject();
        this.initChildMethods()
    }

    //function to inicializate child methods
    protected abstract initChildMethods():void

    protected setCurrentAction() {

        if (this.activetedRoute.snapshot.url[0].path == "new") {

            this.currentAction = "new"
            this.resetBehaviorSubject()

        } else if (this.activetedRoute.snapshot.url[0].path == "edit") {

            this.currentAction = 'edit'

        } else {

            this.currentAction = "unknown"

        }

    }

    loadObject() {
        this.formSubscription.add(this.baseService.getObject(this.objTypeName)
        .subscribe((object: T) => {
            this.object = object
            this.objectForm.patchValue(object)
        }))
    }

    submitForm() {
        this.isButtonLoading = true;

        if (this.currentAction == "new") {
            this.checkTypeOfCreateObject();

        } else if (this.currentAction == 'edit') {
            this.checkTypeOfUpdateObject();
        } else {// currentAction == "edit"
            this.submitFormOnChild();
        }
    }

    checkTypeOfUpdateObject() {

        if(this.hasImageFile())
        {
            this.updateObjectWithImage()
        }else{
            this.updateObject()
        }
    }

    checkTypeOfCreateObject():void {
        if(this.hasImageFile())
        {
            this.createObjectWithImage()
        }else{
            this.createObject();
        }
    }

    updateObject() {

        let resource: T = this.copyJsonDataToObjectFunction(this.objectForm.value);

        this.formSubscription.add(this.baseService.update(resource)
        .subscribe(
            resource => this.actionsForSuccess(resource),
            () => this.actionsForError()
        ))

    }

    updateObjectWithImage() {
        let formData=this.generateFormData(this.objectForm.value);

        this.formSubscription.add(this.baseService.updateDataWithImage(formData)
        .subscribe(
            success => this.actionsForSuccess(success),
            () => this.actionsForError()
        ))

    }

    createObject() {

        const object: T = this.copyJsonDataToObjectFunction(this.objectForm.value)

        this.formSubscription.add(this.baseService.create(object)
        .subscribe(
            success => this.actionsForSuccess(success),
            () => this.actionsForError()
        ))

    }

    createObjectWithImage() {

        let formData=this.generateFormData(this.objectForm.value);

        this.formSubscription.add(this.baseService.createDataWithImage(formData)
        .subscribe(
            success => this.actionsForSuccess(success),
            () => this.actionsForError()
        ))

    }


    protected generateFormData(objectForm:any):FormData {

         // criando um formData
        let formData = new FormData();

        // deletando o campo de imagem actual
        delete objectForm['pic'];

        // convertendo o objectForm para formData
        for (var key in objectForm) {
            formData.append(key, objectForm[key]);
        }

        if(this.checkIfInputControlNameIsImageArray()){
            // Anexando a imagem ao formdata
            this.arrayOfimages.forEach(img => {
                formData.append(this.imageInputControlName,img,img.name);
            });

        }else{
            // Anexando a imagem ao formdata
            formData.append(this.imageInputControlName, this.imageFile.nativeElement.files[0], this.imageFile.nativeElement.files[0].name);
        }

        return  formData;
    }

    checkIfInputControlNameIsImageArray():boolean {
        if(this.imageInputControlName.indexOf('[')==-1)
            return false;
        else
            return true
    }

    protected hasImageFile():boolean {

        if(!!this.imageFile){
            if(!!this.imageFile.nativeElement.value){
                return true
            }
        }

        if(this.arrayOfimages.length > 0){
            return true
        }

        return false
    }

    // PRIVATE METHODS
    back(){
       this.redirect.navigateByUrl(this.backRoute)
    }


    protected actionsForError(): void {

        this.isButtonLoading = false;

    }

    protected actionsForSuccess(success?: any): void {

        if(this.currentAction=='new') this.objectForm.reset()

        this.toastr.successToastr(success || "Dados salvos com sucesso!");

        this.isButtonLoading = false;
    }

    protected previewSelectedImages(event:any):void{

        if (event.target.files && event.target.files[0]) {
          var filesAmount = event.target.files.length;

          for (let i = 0; i < filesAmount; i++) {

                    var reader = new FileReader();

                    this.arrayOfimages.push(event.target.files[i]);

                    reader.onload = (event:any) => {
                       this.arrayOfimagesUrls.push(event.target.result);
                    }

                    reader.readAsDataURL(event.target.files[i]);
            }
        }

    }

    protected removeSelectedImage(url:string){
        let  index=this.arrayOfimagesUrls.indexOf(url)
        this.arrayOfimagesUrls.splice(index,1)
        this.arrayOfimages.splice(index,1)
    }

    // function build form
    protected abstract buildForm(): void

    // function to execute any kind o action in child
    protected submitFormOnChild():void{}

    // set breadcrumb title for child
    protected setChildPageTitle(): string {return}

    // function take jsondata and convert to specifique object
    // protected copyJsonDataToObjectFunction: (jsonData: any) => T

    // permissões
    isAdmin():boolean{
        return this.auth.user.roles[0].name==='admin';
    }

    isManager():boolean{
        return this.auth.user.roles[0].name==='manager';
    }

    isUserClub():boolean{
        return this.auth.user.roles[0].name==='userClube';
    }

    isUserKhuzela():boolean{
        return this.auth.user.roles[0].name==='user';
    }

    isAdminOrUserKhuzela():boolean{
        return this.isAdmin() || this.isUserKhuzela();
    }

    isManagerOrUserClub():boolean{
        return this.isManager() || this.isUserClub();
    }

    isAdminOrManager():boolean{
        return this.isManager() || this.isAdmin();
    }

    isAll():boolean{
      return this.isAdmin() || this.isUserKhuzela() || this.isManager() || this.isUserClub();
    }
}
